import States from '../common/states';
import { ApiError, NetworkError } from '../types/errors';
import Constants from '../utils/constants';

export type ResponseObject = {
  servertime: number;
};

export default async function sendRequest(
  url: string,
  headers?: HeadersInit,
  body?: BodyInit,
  method?: string,
): Promise<any> {
  const controller = new AbortController();
  const t = setTimeout(
    () => controller.abort('Timeout'),
    Constants.fetchTimeout,
  );

  method ??= body !== undefined ? 'POST' : 'GET';
  if (States.settingsState.fetchLog) console.log('REQ', method, url);

  try {
    const response = await fetch(url, {
      method,
      headers,
      body,
      signal: controller.signal,
    });
    if (States.settingsState.fetchLog) console.log('RES', response.status, url);

    const result = await response.json();
    return result;
  } catch (error: any) {
    if (States.settingsState.fetchLog) console.log('ERR', url);
    if (error instanceof TypeError) throw new NetworkError(error.message);
    else throw new NetworkError('Unknown error');
  } finally {
    clearTimeout(t);
  }
}

export function getSession() {
  const session = States.mainState.session;
  if (session === undefined) throw new ApiError(-1, 'Session not found');
  return [session.sidName, session.sid];
}
